export default __webpack_public_path__ + "static/404-54a4c106f1e72db2d1ed07b6dd3e620b.svg";